module.exports = __webpack_public_path__ + "img/lasource-12.483ca685.jpg";